module.exports = __webpack_public_path__ + "static/media/imgthumb_10.158a522b.ico";